'use client';

import {trackPhasesListingCardClick, trackPhasesListingRegisterInterestClick, trackPhasesListingViewItemClick} from '../../analytics';
import {EXPANSIONS_EMPTY} from '../../content';
import type {PhaseCardView} from '../../model';
import {phaseStatusKey} from '../../model';
import {phaseHref} from '../../routing';
import {LOCATION_ICON} from '../listing';
import {Chip} from '../primitives';
import {EntityGridListing} from './EntityGridListing';

export interface PhasesGridCardListingProps {
  locale: string;
  items: PhaseCardView[];
  eyebrow?: string;
  projectId?: string;
  projectName?: string;
}

export function PhasesGridCardListing({locale, items, eyebrow, projectId, projectName}: PhasesGridCardListingProps) {
  const analyticsExtra = {project_id: projectId, project_name: projectName};
  return (
    <EntityGridListing
      titleKey="phases"
      eyebrow={eyebrow}
      empty={EXPANSIONS_EMPTY}
      items={items.map(phase => ({
        id: phase.uuid,
        registerInterest: {projectId, phaseId: phase.uuid},
        title: phase.title,
        image: phase.image.src,
        href: phaseHref(locale, phase.uuid),
        tags: phase.projectLabel ? (
          <Chip color="dark" size="medium">
            {phase.projectLabel}
          </Chip>
        ) : undefined,
        badgeKey: phaseStatusKey(phase.status),
        statusAsTag: true,
        primaryMeta: phase.location ? {icon: LOCATION_ICON, label: phase.location} : undefined,
      }))}
      analytics={{
        onCardClick: item => {
          trackPhasesListingCardClick(item, analyticsExtra);
        },
        onViewItemClick: item => {
          trackPhasesListingViewItemClick(item, analyticsExtra);
        },
        onRegisterInterestClick: trackPhasesListingRegisterInterestClick,
      }}
    />
  );
}

PhasesGridCardListing.displayName = 'PhasesGridCardListing';
